import { action, observable, makeObservable } from 'mobx';
import {contentLoaders, SuccessResponse} from '../../../../domain';
import {HttpPromiseState, SaveStateHolder} from '../../../../lib/helpers';

export class DeleteContentStore implements SaveStateHolder {
  @observable.ref
  save: HttpPromiseState<SuccessResponse> | null;

  constructor(readonly blockId: number,
              readonly contentId: number) {
    makeObservable(this);
    this.blockId = blockId;
    this.contentId = contentId;
    this.save = null;
  }

  @action
  complete() {
    if (this.save?.isPending === true)
      return;
    this.save = contentLoaders.x9content.delete(this.contentId);
  }
}
